export enum RouteKeys {
  List = '/brand',
  New = '/brand/new',
  Edit = '/brand/:id',
}
